// this file is generated by update_shopify_store_data.py at 2026-01-26 20:19:31.015457
var courses = [
    {
        "course_id": "62A678A5-2C48-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: Bringing the Nursing Scope and Standards to Life - Part 1",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nYou have a copy of the most recent Nursing Scope and Standards of Practice \u2014now what? What does this have to do with your day-to-day nursing practice? The answer, a lot! The Nursing Scope & Standards is designed as a blueprint for everyday nursing practice, for nurses at all levels and in all specialties.\r\nThis course explores the significance of integrating the Scope and Standards into everyday nursing. You will identify practical and innovative strategies organizations can use to adopt the standard\u2019s framework and competencies into their nurses\u2019 daily practice. What better way to build your nurses\u2019 competencies on than the quintessential and peer-reviewed resource designed to guide nursing practice?",
        "learning_objectives_html": "Key Learning Outcomes:<br />\r\n<br />\r\nExamine how the Nursing Scope and Standards can be used for development of competency statements<br />\r\n<br />\r\nDiscuss practical and innovative ways to implement the Nursing Scope and Standards into everyday nursing practice",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];